import {router} from "./router";

export const Breadcrumbs = {

	history: [],

	/**
	 * Will add to your navigation history
	 * @param {{path: String, handler: String, meta: Object, params: Object}} route
	 * @param {*} params
	 * @constructor
	 */
	Add: (route, params) => {
		route.params = params;
		router.currentRoute = route;
		Breadcrumbs.history.push(route);
	},

	/**
	 * Will get the last breadcrumb set
	 * @returns {{path: String, handler: String, meta: Object, params: Object}}
	 */
	getLast: () => {
		const last = Breadcrumbs.history[Breadcrumbs.history.length -2];
		if (last) {
			Breadcrumbs.history.splice((Breadcrumbs.history.length -1), 1);
			return last;
		}
	},

	/**
	 * Will get all history
	 * @returns {[]}
	 */
	getAll: () => Breadcrumbs.history,

};